// Hosted (Browserbase) sessions have no viewer of their own: operators use
// the Dream operator page, which fetches the live view behind ops auth.
// Electron sessions keep opening their own viewer URL.
const HOSTED_INSTANCE_ID = 'browserbase';
export const OPERATOR_PATH_PREFIX = '/ops/intervention/';

interface InterventionRef {
  commandId: string;
  instanceId?: string | null;
  vncUrl?: string | null;
}

/** Whether the intervention is resolved from the Dream operator page (typed outcomes). */
export function usesOperatorPage(intervention: InterventionRef): boolean {
  return (
    intervention.instanceId === HOSTED_INSTANCE_ID ||
    (intervention.vncUrl ?? '').includes(OPERATOR_PATH_PREFIX)
  );
}

export function interventionOperatorHref(
  intervention: InterventionRef,
): string | null {
  if (usesOperatorPage(intervention)) {
    return `${OPERATOR_PATH_PREFIX}${encodeURIComponent(intervention.commandId)}`;
  }
  return intervention.vncUrl || null;
}
